import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogModalComponent } from 'src/app/components/dialog-modal/dialog-modal.component';
import { DialogTncComponent } from 'src/app/components/dialog-tnc/dialog-tnc.component';
import { DialogConfirmationConsentComponent } from 'src/app/components/dialog-confirmation-consent/dialog-confirmation-consent.component';
import { pdpApiService } from 'src/app/services/pdp-api.service';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsEventsService } from "../../services/google-analytics.service";

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.css']
})
export class ConsentComponent implements OnInit {
  @ViewChild('top') topPolicy!: ElementRef;
  // @ViewChild('bottom') bottomPolicy!: ElementRef;
  @Input() consent: any;
  @Input() msisdn: string = ''
  @Input() signature: string = ''
  @Input() isAutoLogin: boolean = false

  currentlang: any;
  modalRef: any;
  drawerTncIoh: boolean = false;

  stateDialog: string = '';
  platform: any;

  showButton: boolean = false;
  consentDetail: boolean = false;
  countY: number = 0;
  countN: number = 0;
  isLoading: boolean = false;

  dataConsentGroup = [
    {
      "displayGroupName_en": "Financial Product & Service",
      "displayContent_en": "Saving, Loan, Digital Wallet, Insurance Services & Investment",
      "displayGroupName_id": "Produk & Layanan Keuangan",
      "displayContent_id": "Tabungan, Pinjaman, Dompet Digital, Layanan Asuransi dan Investasi",
      "consentGroup": "group1",
      "consentSubgroup": "1G-Financial Products & Services",
      "response": false
    },
    {
      "displayGroupName_en": "Digital Services and Partner",
      "displayContent_en": "Updates and offers for third-party services, digital value-added services, and new products",
      "displayGroupName_id": "Layanan Digital dan Partner",
      "displayContent_id": "Pembaruan dan penawaran untuk layanan pihak ketiga, layanan tambahan digital, dan produk baru",
      "consentGroup": "group1",
      "consentSubgroup": "1D-Digital Services and Partner Offers",
      "response": false
    },
    {
      "displayGroupName_en": "E-Commerce Deals",
      "displayContent_en": "Special offers, promotions, and discounts from e-commerce platforms",
      "displayGroupName_id": "Penawaran E-Commerce",
      "displayContent_id": "Penawaran spesial, promosi, dan diskon dari platform e-commerce",
      "consentGroup": "group1",
      "consentSubgroup": "1H-E-Commerce Deals",
      "response": false
    },
    {
      "displayGroupName_en": "Daily Essentials & FMCG",
      "displayContent_en": "Promotions and campaigns for FMCG, food and beverages, or other consumer product and services",
      "displayGroupName_id": "Kebutuhan Harian & FMCG",
      "displayContent_id": "Promosi dan kampanye FMCG, makanan & minuman, serta produk dan layanan konsumen lainnya",
      "consentGroup": "group1",
      "consentSubgroup": "1I-Daily Essentials & FMCG",
      "response": false
    },
  ]

  constructor(
    private router: Router,
    public translate: TranslateService,
    private modalService: NgbModal,
    private pdpService: pdpApiService,
    public googleAnalyticsService: GoogleAnalyticsEventsService,
  ) {
  }

  ngOnInit(): void {
    this.currentlang = localStorage.getItem('language');
    this.translate.use(this.currentlang);
    this.translate.setDefaultLang(this.currentlang);

    setTimeout(() => {
      this.platform = localStorage.getItem('platform');
    }, 100);

    this.consent.consentList.forEach((list: any) => {
      let index = this.dataConsentGroup.findIndex((group: any) => group.consentSubgroup === list.consentSubgroup);
      if (index !== -1) {
        this.dataConsentGroup[index].response = list.response === 'N' ? true : false;
      }
    });
  }

  getLang() {
    return localStorage.getItem('language');
  }

  toConsentDetail() {
    this.consentDetail = true;
  }

  agree() {
    //this.stateDialog = 'update_success_1'
    this.dataConsentGroup.forEach((el: any) => {
      el.response = false;
    });
    this.save(0)
  }

  agreeAll() {
    //this.stateDialog = 'update_success_2'
    this.dataConsentGroup.forEach((el: any) => {
      el.response = false;
    });
    this.save(0);
  }

  continue() {
    let indexY = this.dataConsentGroup.findIndex((el: any) => el.response);
    if (indexY === -1) {
      // NO SELECT ANYTHING
      this.agreeAll();
    } else {
      this.confirmation();
    }
  }

  confirmation() {
    let notChoosen: any[] = []
    this.dataConsentGroup.forEach((el: any) => {
      el.response ? notChoosen.push({
        "displayGroupName_en": el.displayGroupName_en,
        "displayGroupName_id": el.displayGroupName_id,
      }) : '';
    });

    if (notChoosen.length !== 0) {
      this.modalRef = this.modalService.open(DialogConfirmationConsentComponent, {
        size: 'md',
        centered: true,
        // backdrop: 'static',
        windowClass: 'dialog-modal'
      });
      this.modalRef.componentInstance.notConsentChoosen = notChoosen;
      this.modalRef.componentInstance.btnAction.subscribe((data: any) => {
        //this.modalRef.close()
        this.save(1)
      });
    }
  }

  save(consent_type: number) {
    //OLD 0 - updates_success_1 - without manage btn - only with first agree/disagree btn
    //OLD 1 - updates_success_2 - with manage btn - with box selected
    //0 - updates_success - dialog type for agree/agree all
    //1 - updates_success_2 - dialog type for disagree
    let state = consent_type ? 'update_success_2' : 'update_success'
    this.countN = 0;
    this.countY = 0;
    let consentList: any[] = [];

    this.dataConsentGroup.forEach((el: any) => {
      consentList.push({
        "consentGroup": el.consentGroup,
        "consentSubgroup": el.consentSubgroup,
        "response": el.response ? 'N' : 'Y'
      })
      this.countN += el.response ? 1 : 0;
      this.countY += el.response ? 0 : 1;
    });

    let index = this.dataConsentGroup.findIndex((el: any) => el.consentSubgroup === '1D-Digital Services and Partner Offers');

    consentList.push({
      "consentGroup": "group1",
      "consentSubgroup": "1E-Digital Services and Partner Offers",
      "response": this.dataConsentGroup[index].response ? 'N' : 'Y',
    })

    let data: any = {
      "invocationId": this.consent.invocationId,
      "msisdn": this.consent.msisdn,
      "Source": localStorage.getItem('source'),
    }

    if (this.countY === this.dataConsentGroup.length) {
      data.consent = 'Y';
    } else if (this.countN === this.dataConsentGroup.length) {
      data.consent = 'N';
    } else {
      data.consentList = consentList;
    }

    this.isLoading = true;
    this.googleAnalyticsService.emitEvent("Submit Consent", "MSISDN", '62' + this.msisdn);
    if (this.isAutoLogin) {
      this.pdpService.updateConsentHash(data).subscribe(res => {
        this.isLoading = false;

        if (res.status) {
          this.consentDetail = false;
          this.stateDialog = state;

          setTimeout(() => {
            this.showButton = this.platform === 'indosat' ? false : true;
          }, 100);
        }
      }, err => {
        this.isLoading = false;
        console.log(err)
      })
    } else {
      data.signature = this.signature;

      this.pdpService.updateConsent(data).subscribe(res => {
        this.isLoading = false;

        if (res.status) {
          this.consentDetail = false;
          this.stateDialog = state;
        }
      }, err => {
        this.isLoading = false;
        console.log(err)
      })
    }
  }

  manageAction() {
    this.stateDialog = ''
    this.isLoading = true;

    if (this.isAutoLogin) {
      this.pdpService.fetchConsentHash(this.msisdn).subscribe(resConsent => {
        if (resConsent.status && resConsent.data.serviceStatus === 0) {
          this.consent = resConsent.data;
          this.consent.consentList.forEach((list: any) => {
            let index = this.dataConsentGroup.findIndex((group: any) => group.consentSubgroup === list.consentSubgroup);
            if (index !== -1) {
              this.dataConsentGroup[index].response = list.response === 'N' ? true : false;
            }
          });
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.errorDialog()
        }
      }, err => {
        this.isLoading = false;
        this.errorDialog()
      })
    } else {
      this.pdpService.fetchConsent('62' + this.msisdn, this.signature).subscribe(resConsent => {
        if (resConsent.status && resConsent.data.serviceStatus === 0) {
          this.consent = resConsent.data;
          this.consent.consentList.forEach((list: any) => {
            let index = this.dataConsentGroup.findIndex((group: any) => group.consentSubgroup === list.consentSubgroup);
            if (index !== -1) {
              this.dataConsentGroup[index].response = list.response === 'N' ? true : false;
            }
          });
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.errorDialog()
        }
      }, err => {
        this.isLoading = false;
        this.errorDialog()
      })
    }
  }

  btnAction() {
    let url = '';

    this.googleAnalyticsService.emitEvent("Got It Button", "platform", this.platform);
    if (this.platform.toLowerCase() === 'im3') {
      url = environment.im3HomePage
    } else {
      url = environment.bimaHomePage
    }

    console.log({ platform: this.platform, url });

    window.location.href = url;
  }

  learnMore(consent: string) {
    this.modalRef = this.modalService.open(DialogTncComponent, {
      size: 'md',
      centered: true,
      // backdrop: 'static',
      windowClass: 'dialog-modal'
    });
    this.modalRef.componentInstance.consent = consent;
    this.modalRef.componentInstance.btnAction.subscribe((data: any) => {
      this.modalRef.close()
    });
    // this.currentlang = localStorage.getItem('language');
    // this.topPolicy.nativeElement.scrollIntoView();

    // if (consent === 'ioh') {
    //   this.drawerTncIoh = true;
    // } else {
    //   this.drawerTncIoh = false;
    //   //this.bottomPolicy.nativeElement.scrollIntoView();
    // }
  }

  manageConsent() {
    this.consent.consentStatus = 'PC';

  }

  errorDialog() {
    this.modalRef = this.modalService.open(DialogModalComponent, {
      size: 'md',
      centered: true,
      // backdrop: 'static',
      windowClass: 'dialog-modal'
    });
    this.modalRef.componentInstance.dialogType = 'fetch_consent';
    this.modalRef.componentInstance.btnAction.subscribe((data: any) => {
      this.modalRef.close()
    });
  }

  // errorDialog() {
  //   this.modalRef = this.modalService.open(DialogModalComponent, {
  //     size: 'md',
  //     centered: true,
  //     // backdrop: 'static',
  //     windowClass: 'dialog-modal'
  //   });
  //   this.modalRef.componentInstance.dialogType = 'tick_both_tnc';
  //   this.modalRef.componentInstance.btnAction.subscribe((data: any) => {
  //     this.modalRef.close()
  //   });
  // }
}
